import { SCol, SRow, SBox, SAlert } from '@avalara/skylab-sdk/react';
import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { getOfferPlanPrice } from '../../../lib/offers';
import { embeddedViewRequested } from '../../../lib/helpers';
import { formatPrice } from '../../../../shared/helpers';
import { selectIsNonAdmin, selectState } from '../../../selectors';
import { purchaseDeflectionWording } from '../../helpers';
import OfferBox from '../box';
import NextButton from './shared/next-button';
import SelectPlanButton from './shared/select-plan-button';
import { FixedWidthPlanWrapper } from './shared/styles';
const AvataxSandboxPlanSelect = ({ plans }) => {
    const [selectedPlanName, selectPlanName] = useState('');
    const isNonAdmin = useSelector(selectIsNonAdmin);
    const { account: { isLoggedIn, }, } = useSelector(selectState);
    useEffect(() => {
        if (plans.length)
            selectPlanName(plans[plans.length - 1].name);
    }, [plans]);
    return (React.createElement(React.Fragment, null,
        (isLoggedIn && isNonAdmin) && React.createElement(SAlert, { status: 'info', noDismiss: true, className: 'margin-all-sm' },
            React.createElement("div", null, purchaseDeflectionWording)),
        React.createElement(OfferBox, { isEmbedded: embeddedViewRequested(), className: 'margin-all-sm pad-all-sm' },
            React.createElement(SRow, null,
                React.createElement(SCol, null,
                    React.createElement("p", { "data-ref": 'buy.plan-select.avatax-sandbox.header-content', className: 'margin-top-sm text-lg' }, "Choose how much AvaTax sandbox access your business needs"))),
            React.createElement(SRow, null, plans === null || plans === void 0 ? void 0 : plans.map(plan => {
                var _a;
                return (React.createElement(SCol, { key: plan.name, span: 'auto', className: 'flex justify-content-center' },
                    React.createElement(FixedWidthPlanWrapper, { onClick: () => selectPlanName(plan.name), selected: selectedPlanName === plan.name, disabled: (isLoggedIn && isNonAdmin) },
                        React.createElement(SBox, { "data-ref": `buy.plan-select.avatax-sandbox.${plan.name}-container`, className: 'margin-bottom-sm margin-top-xs text-center' },
                            React.createElement("p", { "data-ref": 'buy.plan-select.avatax-sandbox.product-item-name', className: 'text-lg' }, (_a = plan.productItems) === null || _a === void 0 ? void 0 : _a[0].name),
                            React.createElement("hr", null),
                            React.createElement("p", { "data-ref": 'buy.plan-select.avatax-sandbox.product-price', className: 'text-xxl' }, formatPrice(getOfferPlanPrice(plan), 0)),
                            React.createElement("hr", null),
                            React.createElement("div", { "data-ref": 'buy.plan-select.avatax-sandbox.select-button-container', className: 'pad-bottom-sm pad-top-xl' },
                                React.createElement(SelectPlanButton, { isSelected: selectedPlanName === plan.name, planName: plan.name, disableButton: (isLoggedIn && isNonAdmin) }))))));
            })),
            React.createElement(SRow, null,
                React.createElement(SCol, { span: 'auto', className: 'flex align-items-center justify-content-end' },
                    React.createElement(NextButton, { selectedPlanName: selectedPlanName, disableButton: (isLoggedIn && isNonAdmin) }))))));
};
export default AvataxSandboxPlanSelect;
